function AppHeader({ level, title }) {
  return (
    <div className="topBar">
      <button className="iconButton" type="button" aria-label="返回">
        ‹
      </button>
      <div className="topTitle">
        <div className="topLevel">{level}</div>
        <div className="topName">{title}</div>
      </div>
      <div className="topRight" />
    </div>
  );
}

export default AppHeader;
